// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__l89qe","label":"Checkbox_label__O-SB1","input":"Checkbox_input__KAVVD","box":"Checkbox_box__ggYMM","text":"Checkbox_text__BhIUJ"};